/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SignupNudgePayloadSideEffectType } from "./SignupNudgePayloadSideEffectType";

export interface SignupNudgePayload {
  side_effect_type: SignupNudgePayloadSideEffectType;
  nudge_type: string;
  conversation_id: string;
}
